<template>
    
    <div class="main">        
        <info :paramId="$route.params.id"></info>
    </div>
    
</template>
<script>

import info from "./info"

export default {
    components:{ info }
}
</script>
